import { HookCreator } from "./apiHookCreators";

export type ApiResponseType<PayloadType> = {
  payload: PayloadType;
  message: string;
};

export type IdParamType = {
  id: number;
};

export const { createGetApiHookCreator: createGetApiHook } = new HookCreator(
  "GET"
);

export const { createUpdateApiHookCreator: createPostApiHook } =
  new HookCreator("POST");

export const { createUpdateApiHookCreator: createPutApiHook } = new HookCreator(
  "PUT"
);

export const { createUpdateApiHookCreator: createDeleteApiHook } =
  new HookCreator("DELETE");

export const { createUpdateApiHookCreator: createPatchApiHook } =
  new HookCreator("PATCH");
